import { createBrowserRouter } from 'react-router-dom';

import RouterAuth from './auth';
import RouterCommon from './common';
import RouterItemManagement from './item-management';
import RouterOrders from './order-management';
import RouterPayments from './payment';
import RouterStores from './stores';
import RouterUsers from './users';

export const router = createBrowserRouter([
  ...RouterAuth,
  ...RouterCommon,
  ...RouterStores,
  ...RouterItemManagement,
  ...RouterUsers,
  ...RouterOrders,
  ...RouterPayments,
]);
